"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.durationFormat = void 0;

const durationFormat = duration => {
  const m = Math.floor(duration / 60);
  const s = Math.floor(duration % 60);
  return "".concat("00".concat(m).slice(-Math.max(2, String(m).length)), ":").concat("00".concat(s).slice(-2));
};

exports.durationFormat = durationFormat;